import styled from 'styled-components';
import theme from 'themes';

export const NotificationIconContainer = styled.div<{ openNotification: boolean }>`
  position: relative;
  cursor: pointer;
  padding-top: 5px;
  color: ${theme.colors.lightGrey10};

  &::before {
    content: '';
    position: absolute;
    top: -4px;
    left: -10px;
    right: -10px;
    bottom: -4px;
    background-color: ${({ openNotification }) =>
      openNotification ? theme.colors.white : 'transparent'};
    border-radius: 4px;
    z-index: -1;
    transition: background-color 0.3s;
  }

  .icon--bell {
    height: 24px;
    width: 20px;
  }
`;
export const TabContainer = styled.div``;

export const FlyoutContent = styled.div`
  padding: 0 1.25rem 0 1.25rem;
`;

export const BellIconBadge = styled.div`
  position: absolute;
  top: 0.1rem;
  right: -0.4rem;
  width: 1rem;
  height: 1rem;
  border-radius: 0.5rem;
  font-size: 0.625rem;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.colors.negativeRed};
  color: white;
`;

export const Badge = styled.span<{ isActive: boolean }>`
  display: inline-block;
  height: 20px;
  width: 20px !important;
  background-color: ${({ isActive }) =>
    isActive ? theme.colors.info300 : theme.colors.lightGrey10};
  color: ${theme.colors.textLightBlack};
  border-radius: 50%;
  margin-left: 5px;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  position: relative;
  top: -2px;
`;

//NoNotifications

export const MessageContainer = styled.div`
  text-align: center;
  color: ${theme.colors.lightGrey8};
  padding-top: 1.75rem;
  font-weight: 600;
`;

export const NoNotificationImage = styled.img`
  max-width: 9.625rem;
  height: 11rem;
  margin-bottom: 0.88rem;
`;

//Accordian
export const AccordionContainer = styled.div`
  margin: 2rem 0;
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${theme.colors.primaryBlue5};
  font-size: 0.875rem;
  font-weight: 600;
  .icons {
    padding-top: 2px;
    display: inline-block;
    vertical-align: middle;
  }
  .icon--chevron-right {
    height: 12px;
  }
`;

export const AccordionContent = styled.div`
  // Additional styles can be added here if needed
`;

export const DashedLine = styled.div`
  border-bottom: 1px dashed ${theme.colors.primaryBlue5};
  flex: 1;
  margin-left: 0.75rem;
`;

//notification card

export const CardContainer = styled.div<{ alertType?: string }>`
  border-bottom: 1px solid ${theme.colors.lightGrey3};
  margin: 0.5rem 0;
  transition: max-height 0.3s ease;
  overflow: hidden;
  background-color: ${({ alertType }) =>
    alertType === 'HIGH' ? `${theme.colors.error300}` : 'inherit'};
`;

export const TopContainer = styled.div`
  padding: 0.25rem 0.75rem;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.span`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
  font-weight: 600;
  flex-grow: 1;
  white-space: nowrap;
`;

export const Circle = styled.div`
  height: 8px;
  width: 8px;
  background-color: #0076cc;
  border-radius: 50%;
  margin-right: 0.4rem;
`;

export const SubtitleContainer = styled.div`
  display: flex;
  align-items: center;
  line-height: 1rem;
  padding-bottom: 0.25rem;
  gap: 0.38rem;

  .machine-id {
    color: #666;
    font-size: 0.625rem;
    font-weight: 600;
  }

  .icon--exclamation-circle {
    height: 16px;
    width: 16px;
    color: ${theme.colors.error200};
  }

  .icon--exclamation {
    height: 16px;
    width: 16px;
    color: ${theme.colors.warning300};
  }

  .icon--shopping-cart {
    height: 16px;
    width: 16px;
    color: ${theme.colors.primaryBlue5};
  }
`;

export const TimeContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 2rem;
  font-size: 0.625rem !important;

  button {
    font-size: 0.625rem !important;
    color: ${theme.colors.primaryBlue5};
  }

  .open-alert {
    font-weight: 600 !important;
  }
`;

export const LeftTimeSection = styled.span`
  color: ${theme.colors.lightGrey8};
  display: flex;
  align-items: center;
  gap: 3rem;
  white-space: nowrap;
`;

export const AlertStatus = styled.span<{ status: string }>`
  font-size: 0.75rem;
  font-weight: 600;
  color: ${({ status }) => {
    if (status === 'HIGH') return `${theme.colors.darkRed}`;
    if (status === 'MEDIUM') return `${theme.colors.warning}`;
    if (status === 'Cart Wheel') return `${theme.colors.primaryBlue5}`;
    return 'inherit';
  }};
`;

export const AlertDescription = styled.div`
  margin-bottom: 8px;

  .alert-description {
    color: ${theme.colors.darkGrey};
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 12px;
    padding-left: 2rem;
  }

  button {
    color: ${theme.colors.primaryBlue5};
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1rem;
  }
`;
